import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";

const Base_URL = process.env.REACT_APP_BE_URL;

const {
  axiosGetCallWithToken,
  axiosPostCallWithToken,
  axiosPutCallWithToken,
  axiosDeleteCallWithToken,
  axiosGetCallHeaderWithToken,
} = AxiosWrapper;

const normalizeError = (error) => {
  let sendError = error;
  if (
    sendError.response !== undefined &&
    sendError.response.data !== undefined &&
    sendError.response.data.message !== undefined
  ) {
    sendError = new Error(sendError.response.data.message);
  } else {
    sendError = new Error(
      "Something unexpected happened." +
      "If the issue persists, please contact our support team for assistance."
    );
  }
  Logger.printStackTrace("Error fetching data:", error);
  return sendError;
};

const handleResponse = (response) => {
  if (response === undefined) {
    throw new Error("No response");
  }
  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};

export const addReceive = async (payload) => {
  let response;
  try {
    response = await axiosPostCallWithToken(
      `${Base_URL}/label_print/addReceive`,
      payload
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const addIssue = async (payload) => {
  let response;
  try {
    response = await axiosPostCallWithToken(
      `${Base_URL}/label_print/addIssue`,
      payload
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchAllReceive = async (po_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getAllReceive`,
      po_no ? { po_no } : {}
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchReceiveById = async (id) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getReceiveById`,
      { id }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchAllIssue = async (work_order_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getAllIssue`,
      work_order_no ? { work_order_no } : {}
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchIssueById = async (id) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getIssueById`,
      { id }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

// Looks up a material's description + UOM from the SAP-synced sq01 data by
// material number. Returns undefined (not throw) when no match exists, so
// callers can leave the description/UOM fields open for manual entry.
export const fetchMaterialBySq01 = async (material_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getMaterialBySq01`,
      { material_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  if (response && response.data && response.data.status === 204) {
    return undefined;
  }
  return handleResponse(response);
};

export const fetchStockBalance = async (material_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getStockBalance`,
      { material_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const updateReceive = async (id, payload) => {
  let response;
  try {
    response = await axiosPutCallWithToken(
      `${Base_URL}/label_print/updateReceive?id=${id}`,
      payload
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const updateIssue = async (id, payload) => {
  let response;
  try {
    response = await axiosPutCallWithToken(
      `${Base_URL}/label_print/updateIssue?id=${id}`,
      payload
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const deleteReceive = async (id) => {
  let response;
  try {
    response = await axiosDeleteCallWithToken(
      `${Base_URL}/label_print/deleteReceive?id=${id}`
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const deleteIssue = async (id) => {
  let response;
  try {
    response = await axiosDeleteCallWithToken(
      `${Base_URL}/label_print/deleteIssue?id=${id}`
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchReceivePoSummary = async (po_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getReceivePoSummary`,
      po_no ? { po_no } : {}
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchReceiveItemsByPo = async (po_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getReceiveItemsByPo`,
      { po_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchIssueWoSummary = async (work_order_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getIssueWoSummary`,
      work_order_no ? { work_order_no } : {}
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchIssueItemsByWo = async (work_order_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getIssueItemsByWo`,
      { work_order_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

// Looks up the latest existing Receive transaction for an exact PO number.
// Returns undefined (not throw) when none exists yet, so callers can open a blank form.
export const fetchLatestReceiveByPo = async (po_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getLatestReceiveByPo`,
      { po_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  if (response && response.data && response.data.status === 204) {
    return undefined;
  }
  return handleResponse(response);
};

// Looks up the latest existing Issue transaction for an exact Work Order number.
export const fetchLatestIssueByWorkOrder = async (work_order_no) => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getLatestIssueByWorkOrder`,
      { work_order_no }
    );
  } catch (error) {
    throw normalizeError(error);
  }
  if (response && response.data && response.data.status === 204) {
    return undefined;
  }
  return handleResponse(response);
};

export const fetchCombinedHistory = async (year, month) => {
  let response;
  try {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getCombinedHistory`,
      params
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchCombinedSummary = async (year, month) => {
  let response;
  try {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getCombinedSummary`,
      params
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const fetchHistoryYears = async () => {
  let response;
  try {
    response = await axiosGetCallWithToken(
      `${Base_URL}/label_print/getHistoryYears`
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

export const exportCombinedHistory = async (year, month) => {
  let response;
  try {
    const yearParam = year ? `year=${year}` : "";
    const monthParam = month ? `&month=${month}` : "";
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/label_print/getCombinedHistoryExport?${yearParam}${monthParam}`,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

// Excel export of a single Receive document's line items — the History
// detail view's own export button, scoped to one PO instead of a date range.
export const exportReceiveItemsByPo = async (po_no) => {
  let response;
  try {
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/label_print/getReceiveItemsByPoExport?po_no=${encodeURIComponent(po_no)}`,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};

// Same as above, for a single Issue document (by Work Order number).
export const exportIssueItemsByWo = async (work_order_no) => {
  let response;
  try {
    response = await axiosGetCallHeaderWithToken(
      `${Base_URL}/label_print/getIssueItemsByWoExport?work_order_no=${encodeURIComponent(work_order_no)}`,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  } catch (error) {
    throw normalizeError(error);
  }
  return handleResponse(response);
};
